import { render, staticRenderFns } from "./GameCollectionCard.vue?vue&type=template&id=7fbb5f52"
import script from "./GameCollectionCard.vue?vue&type=script&lang=js"
export * from "./GameCollectionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports